




























import { computed, defineComponent } from '~/utils/nuxt3-migration'
import { ciStar } from '~/icons/source/solid/star'
import { ciStarHalf } from '~/icons/source/solid/star-half'
import { ciStar as ciStarR } from '~/icons/source/regular/star'

export default defineComponent({
  props: {
    rating: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const hasHalfStar = computed(() => {
      // to normalize the rating we round it up to half (e.g. 4.3 -> 4.5)
      const normalizedRating = Math.round(parseFloat(props.rating) * 2) / 2

      return Math.floor(normalizedRating) !== normalizedRating
    })

    const fullStars = computed(() =>
      hasHalfStar.value
        ? parseInt(props.rating)
        : Math.round(parseFloat(props.rating))
    )

    const emptyStars = computed(() =>
      hasHalfStar.value ? 5 - fullStars.value - 1 : 5 - fullStars.value
    )

    return {
      ciStar,
      ciStarHalf,
      ciStarR,
      fullStars,
      hasHalfStar,
      emptyStars
    }
  }
})
